const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-['Playfair_Display']">
            30 Years Serving Brooklyn
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              For over three decades, Brooklyn Auto Body Shop has been the trusted choice for <strong>New York auto repair</strong> and <strong>collision services</strong>. Our team of <strong>experienced mechanics</strong> brings unmatched expertise to every <strong>accident repair</strong>, maintenance job, and insurance claim.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Located in Brooklyn's Industrial Area, we provide convenient access for car owners throughout New York City. Whether you need emergency <strong>roadside assistance</strong>, routine <strong>car maintenance</strong>, or comprehensive <strong>collision repair</strong>, our <strong>reliable body shop</strong> delivers <strong>quality work</strong> every time.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We work with all insurance companies, warranty providers, and extended warranty companies to ensure your repairs are covered and hassle-free. Our commitment to excellence and customer satisfaction has made us Brooklyn's premier destination for auto repair services.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/fa4e9797f209c8918f42ec69cdc01053.jpg"
                alt="Brooklyn Auto Body Shop Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=Advanced%20automotive%20repair%20equipment%20and%20diagnostic%20tools%20in%20modern%20Brooklyn%20auto%20shop%2C%20state%20of%20the%20art%20technology%20for%20collision%20repair%20and%20vehicle%20maintenance%2C%20clean%20organized%20professional%20workspace&width=400&height=500&seq=about-002&orientation=portrait"
                alt="Modern Auto Repair Equipment"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg -mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=Before%20and%20after%20collision%20repair%20comparison%20showing%20damaged%20car%20transformed%20to%20perfect%20condition%2C%20professional%20auto%20body%20work%20results%20from%20Brooklyn%20body%20shop%2C%20quality%20restoration%20work%20visible&width=400&height=500&seq=about-003&orientation=portrait"
                alt="Before and After Repair"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Satisfied%20customer%20receiving%20car%20keys%20from%20mechanic%20in%20Brooklyn%20auto%20body%20shop%2C%20friendly%20professional%20service%20interaction%2C%20clean%20modern%20facility%20showing%20customer%20satisfaction%20and%20trust&width=400&height=500&seq=about-004&orientation=portrait"
                alt="Customer Service Excellence"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-2xl p-8 text-center">
            <i className="ri-award-fill text-5xl text-orange-600 mb-4"></i>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Certified Technicians</h3>
            <p className="text-gray-600">
              Our mechanics are certified and continuously trained on the latest auto repair techniques
            </p>
          </div>
          <div className="bg-gray-50 rounded-2xl p-8 text-center">
            <i className="ri-shield-check-fill text-5xl text-orange-600 mb-4"></i>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Quality Guarantee</h3>
            <p className="text-gray-600">
              We stand behind our work with comprehensive warranties on all repairs and services
            </p>
          </div>
          <div className="bg-gray-50 rounded-2xl p-8 text-center">
            <i className="ri-customer-service-2-fill text-5xl text-orange-600 mb-4"></i>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Customer First</h3>
            <p className="text-gray-600">
              Your satisfaction is our priority with transparent pricing and excellent communication
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
